import { CapTableDetailsModel } from 'api';
import { CaptableService } from 'services';
import { CREATE_CAPTABLE_PROFORMA, GET_CAPTABLE_INFO, SET_CAPTABLE_INFO } from './types';

const finalAllocationRequests = new Map<number, Promise<unknown>>();

export const setCaptableInfo = (captableInfo: Partial<CapTableDetailsModel>) => ({
  type: SET_CAPTABLE_INFO,
  captableInfo,
});

export const getCapTableInfo = (capTableId: number) => ({
  type: GET_CAPTABLE_INFO,
  capTableId,
});

export const createCapTableProForma = (capTableInfo: CapTableDetailsModel) => ({
  type: CREATE_CAPTABLE_PROFORMA,
  capTableInfo,
});

export const verifyIfHasFinalAllocation = async (capTableId: number) => {
  const existingRequest = finalAllocationRequests.get(capTableId);
  if (existingRequest) {
    return existingRequest;
  }

  const captableService = new CaptableService();
  const request = captableService
    .gotFinalAllocation(capTableId)
    .catch((error: unknown) => ({ ...(error as object) }))
    .finally(() => {
      finalAllocationRequests.delete(capTableId);
    });

  finalAllocationRequests.set(capTableId, request);
  return request;
};

export const checkForMeasurementDates = async (capTableId: number) => {
  const captableService = new CaptableService();
  try {
    const hasMeasurementDates = await captableService.hasMeasurementDates(capTableId);
    return hasMeasurementDates;
  } catch (error: unknown) {
    return { ...(error as object) };
  }
};
